export const getBase64 = (file, callback) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => callback(null, reader.result);
  reader.onerror = (error) => callback(error, null);
};
